var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.29,
    height: 32.29,
    viewBox: "0 0 32.29 32.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28031",
    "data-name": "Grupo 28031",
    transform: "translate(-206.855 -215.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_66304",
    "data-name": "Trazado 66304",
    d: "M230.5,206.673a1.472,1.472,0,0,1-2.082,0L225.3,203.55l-3.123,3.123a1.472,1.472,0,0,1-2.083-2.082l3.123-3.124-3.123-3.123a1.472,1.472,0,1,1,2.083-2.082l3.123,3.123,3.123-3.123a1.472,1.472,0,0,1,2.082,2.082l-3.123,3.123,3.123,3.124A1.472,1.472,0,0,1,230.5,206.673Z",
    transform: "translate(-2.294 30.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28027",
    "data-name": "Grupo 28027",
    transform: "translate(2.827 382.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108687",
    "data-name": "Trazado 108687",
    d: "M220.173-166.271a16.145,16.145,0,0,0-16.145,16.145,16.145,16.145,0,0,0,16.145,16.145,16.145,16.145,0,0,0,16.145-16.145A16.145,16.145,0,0,0,220.173-166.271Zm0,30.315A14.17,14.17,0,0,1,206-150.126a14.17,14.17,0,0,1,14.17-14.17,14.17,14.17,0,0,1,14.17,14.17A14.17,14.17,0,0,1,220.173-135.956Z",
    transform: "translate(0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.e659e89194975117015eadaf20daffec.svg";
export { ForwardRef as ReactComponent };